import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Icon } from '../../icon/icon';

interface BucketItem {
  id: string;
  name: string;
  state: string | { icon: { name: IconProp; color?: string; title?: string; spin?: boolean } };
}

interface Props {
  buckets: BucketItem[];
}

const BucketsTable = (props: Props) => {
  const { t } = useTranslation();
  return (
    <Component>
      <thead>
        <tr>
          <th>{t('projectSettings.status.bucketTable.s3Bucket', { ns: 'components' })}</th>
          <th>{t('projectSettings.status.bucketTable.statusColumn', { ns: 'components' })}</th>
        </tr>
      </thead>
      <tbody>
        {props.buckets.map((x) => (
          <tr key={x.id}>
            <td>{x.name}</td>
            <td>
              {typeof x.state === 'string' ? (
                x.state
              ) : (
                <Icon
                  color={x.state.icon.color}
                  icon={x.state.icon.name}
                  spin={x.state.icon.spin}
                  title={x.state.icon.title}
                />
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Component>
  );
};

const Component = styled.table`
  margin: 1em 0 0 0;
  border-collapse: collapse;

  th {
    font-weight: 600;
    text-align: left;
  }

  td:first-child {
    padding: 0.2em 1em 0.2em 0;
  }
  td:nth-child(2) {
    text-align: center;
  }
`;

export { BucketsTable, BucketItem as BucketsTableItem, Props as BucketsTableProps };
